import axios from 'axios'
import { logout, getAccountSet, getUser } from './sessionManager'
import { buildSignHeaders } from './sign'
import { normalizeKeys } from './normalize'

// 运行时配置优先（编译后可修改 dist/config.js），其次读 env
const baseURL = (window.__APP_CONFIG__ && window.__APP_CONFIG__.API_BASE_URL)
  || process.env.VUE_APP_API_BASE_URL
  || '/api'

// CloudWeb 基础 URL（旧系统）
const cloudWebBaseURL = (window.__APP_CONFIG__ && window.__APP_CONFIG__.CLOUDWEB_BASE_URL)
  || process.env.VUE_APP_CLOUDWEB_BASE_URL
  || 'http://localhost/BPM'

const http = axios.create({
  baseURL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
})

// 请求拦截器：自动携带 Token 与 HMAC 签名头
http.interceptors.request.use(
  async config => {
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // 账套 + 账号（用于后端网关层签名鉴权）
    const tenantId = getAccountSet() || ''
    const user = getUser()
    const account = (user && (user.account || user.Account)) || ''

    // 生成签名头：X-App-Id / X-Tenant-Id / X-Account / X-Timestamp / X-Nonce / X-Signature
    const signHeaders = await buildSignHeaders(tenantId, account)
    Object.keys(signHeaders).forEach(k => {
      config.headers[k] = signHeaders[k]
    })

    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器：统一错误处理 + PascalCase→camelCase 自动转换
http.interceptors.response.use(
  response => {
    // Blob/arraybuffer 类型不转换（文件下载等）
    if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
      return response.data
    }
    return normalizeKeys(response.data)
  },
  error => {
    if (error.response) {
      const { status } = error.response
      switch (status) {
        case 401:
          // Token 过期或签名失效，跳转登录
          logout()
          break
        case 403:
          console.warn('权限不足或签名校验失败')
          break
        case 500:
          console.error('服务器内部错误')
          break
        default:
          break
      }
    }
    return Promise.reject(error)
  }
)

export default http
export { cloudWebBaseURL }
